import { Link } from 'react-router-dom';
import LogoWatermark from '@/components/feature/LogoWatermark';

const reasons = [
  {
    icon: 'ri-shield-check-line',
    title: 'Fully Licensed & Insured',
    desc: 'We carry full licensing and comprehensive insurance coverage, giving you complete peace of mind on every project.',
  },
  {
    icon: 'ri-group-line',
    title: 'Family-Owned Business',
    desc: 'As a family-run company, we treat every client like family — with respect, honesty, and a personal touch you won\'t find with large corporations.',
  },
  {
    icon: 'ri-award-line',
    title: '10+ Years Experience',
    desc: 'Over a decade of hands-on experience in residential and commercial construction, delivering quality results project after project.',
  },
  {
    icon: 'ri-building-line',
    title: 'Residential & Commercial',
    desc: 'From home renovations to commercial build-outs, our team has the expertise to handle projects of any scale.',
  },
  {
    icon: 'ri-price-tag-3-line',
    title: 'Honest Pricing',
    desc: 'Transparent, upfront pricing with no hidden fees. We provide detailed estimates so you know exactly what to expect.',
  },
  {
    icon: 'ri-chat-3-line',
    title: 'Bilingual Team',
    desc: 'Our team communicates fluently in both English and Spanish, ensuring clear and comfortable communication for all clients.',
  },
  {
    icon: 'ri-calendar-check-line',
    title: 'On-Time Completion',
    desc: 'We respect your time and schedule. Projects are completed within agreed timelines without cutting corners.',
  },
  {
    icon: 'ri-hand-heart-line',
    title: 'Quality Craftsmanship',
    desc: 'We take pride in every detail. From materials to finishing touches, quality is never compromised.',
  },
];

export default function WhyChooseUs() {
  return (
    <section className="py-16 md:py-24 px-4 md:px-6 lg:px-10 bg-background-50 relative overflow-hidden">
      <LogoWatermark opacity={0.05} />
      <div className="relative max-w-6xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block text-xs md:text-sm font-medium tracking-wider uppercase text-accent-600 mb-3">
            Why Work With Us
          </span>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight">
            What Sets{' '}
            <span className="text-primary-500">Rafael M&C</span> Apart
          </h2>
          <p className="mt-4 text-foreground-600 max-w-2xl mx-auto text-sm md:text-base leading-relaxed">
            We're not just another contracting company. We're your neighbors, committed to building lasting relationships through exceptional work and unwavering integrity.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {reasons.map((reason) => (
            <div
              key={reason.title}
              className="group p-6 rounded-xl bg-transparent border border-background-300/50 hover:border-primary-300 transition-all cursor-default"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-primary-50 text-primary-500 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-all">
                <i className={`${reason.icon} text-lg`}></i>
              </div>
              <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">
                {reason.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {reason.desc}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <Link
            to="/about"
            className="inline-flex items-center gap-2 text-sm font-semibold text-primary-600 hover:text-primary-700 transition-colors cursor-pointer"
          >
            Learn more about our story
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}